import { render, staticRenderFns } from "./UploadStocks.vue?vue&type=template&id=193bb5fa&scoped=true"
import script from "./UploadStocks.vue?vue&type=script&lang=js"
export * from "./UploadStocks.vue?vue&type=script&lang=js"
import style0 from "./UploadStocks.vue?vue&type=style&index=0&id=193bb5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193bb5fa",
  null
  
)

export default component.exports